import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  assetDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './bulk-delete-risks-dialog.controller';
import template from './bulk-delete-risks-dialog.html';
import bulkDeleteRisksConfirmDialog from '../dialog.bulkDeleteRisksConfirmDialog';


class dialogService {
  getOptions($event, { riskType, assessmentId }) {
    return {
      controller,
      controllerAs: 'bulkDeleteRisksDialogVM',
      locals: {
        riskType,
        assessmentId,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.admin.risk.bulkDeleteRisksDialog', [
  ngCookies,
  assetDataService,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
  bulkDeleteRisksConfirmDialog,
])
  .service('bulkDeleteRisksDialog', dialogService)
  .name;
